import React from 'react';
import { motion } from 'framer-motion';
import { VolumeX, Activity, Radio } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    icon: <VolumeX className="w-8 h-8 text-neon-magenta" data-id="element-169" />,
    title: 'The Silence of Passive Play',
    description: "Traditional rhythm games feel disconnected. You're just pressing buttons, not feeling the music. The immersion is broken before it begins."
  }, {
    icon: <Radio className="w-8 h-8 text-neon-amber" data-id="element-170" />,
    title: 'Generic Audio Libraries',
    description: 'Repetitive, stock soundtracks that lack soul. Gamers deserve curated, high-fidelity audio that drives the gameplay, not just background noise.'
  }, {
    icon: <Activity className="w-8 h-8 text-neon-cyan" data-id="element-171" />,
    title: 'Sync Latency Issues',
    description: 'When the beat drops but the visual lags, the magic dies. Poor synchronization kills the flow state essential for true rhythm gaming.'
  }];
  return <section id="problems" className="py-24 bg-surface relative overflow-hidden" data-id="element-172">
      {/* Waveform Background */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/20 to-transparent" data-id="element-173" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/20 to-transparent" data-id="element-174" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-175">
        <div className="text-center mb-16" data-id="element-176">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-white mb-6" data-id="element-177">
            THE{' '}
            <span className="text-gray-600 line-through decoration-neon-magenta decoration-4" data-id="element-178">
              NOISE
            </span>{' '}
            BARRIER
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-179">
            The gaming industry has lost its rhythm. We identified the
            dissonance preventing true audio-visual immersion.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-180">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-background/50 p-8 rounded-xl border border-white/5 hover:border-neon-cyan/50 transition-colors group" data-id="element-181">
              <div className="bg-surface w-16 h-16 rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 border border-white/10 group-hover:border-neon-cyan/30 shadow-lg" data-id="element-182">
                {problem.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-4 font-display" data-id="element-183">
                {problem.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-184">
                {problem.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}